module.exports = __webpack_public_path__ + "static/media/_intro.ef7264da.jpeg";